import * as React from "react"
import moment from "moment"
import { FormattedMessage } from "react-intl"
import ResetPasswordForm from "./ResetPasswordForm/ResetPasswordForm"
import ErrorMessage from "./ErrorMessage/ErrorMessage"
import SuccessMessage from "./SuccessMessage/SuccessMessage"
import "./ResetPassword.scss"
import { Link } from "react-router-dom"
import { HOME } from "constants/paths"
import { ReactComponent as PhronesisLogo } from "assets/images/logo-phronesis-vertical.svg"
import { IconWrapper } from "components/Shared/IconWrapper"

const ResetPassword: React.FC = (): JSX.Element => {
	const [hasError, setError] = React.useState<boolean>(false)
	const [errorType, setErrorType] = React.useState<string>("")
	const [success, setSuccess] = React.useState<boolean>(false)

	const urlSearchParams = new URLSearchParams(location.search)
	const resetToken = urlSearchParams.get("resetToken")
	const className = "reset-password"

	const toggleHasError = () => {
		setError((hasError) => !hasError)
	}

	const toggleHasSuccess = () => {
		setSuccess((success) => !success)
	}

	const validateShowForm = () => resetToken && !hasError && !success
	const validateShowSuccess = () => !hasError && success

	return (
		<div className={className}>
			<div className="header secondary">
				<div className={"header-bottom"}>
					<div className="header-logo">
						<Link to={HOME}>
							<IconWrapper
								size={32}
								icon={PhronesisLogo}
								alt="Phronesis Logo"
								className="header-image"
							/>
						</Link>
					</div>
				</div>
			</div>
			<div data-testid="reset-password" className={`${className}-container`}>
				<div className={`${className}-body`}>
					{validateShowForm() ? (
						<ResetPasswordForm
							setError={toggleHasError}
							setSuccess={toggleHasSuccess}
							setErrorType={setErrorType}
						/>
					) : validateShowSuccess() ? (
						<SuccessMessage />
					) : (
						<ErrorMessage type={errorType} />
					)}
				</div>
			</div>
			<div className={`${className}-footer`}>
				<FormattedMessage
					id="phronesis.footer.copyright"
					values={{ year: moment().format("YYYY") }}
				/>
			</div>
		</div>
	)
}

export default ResetPassword
